import { Injectable, signal } from '@angular/core';
import { NavigationItem } from '../../interfaces/navigation-items';
import { NavigationItemsService } from '../navigation-items-service/navigation-items.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentNavigationItemService {
  private readonly _currentNavigationItem = signal<NavigationItem>(null as any);
  readonly currentNavigationItem = this._currentNavigationItem.asReadonly();

  constructor(private navigationItems: NavigationItemsService) {
    this._currentNavigationItem.set(this.navigationItems.getStartPage());
  }

  getCurrentNavigationItemByPathName(pathName: string): NavigationItem {
    const navItem = this.navigationItems
      .getNavigationItems()
      .find((item) => item.path === pathName);
    return navItem ?? this.navigationItems.getStartPage();
  }

  set(item: NavigationItem): void {
    this._currentNavigationItem.set(item ?? this.navigationItems.getStartPage());
  }
}
